/**
 * Stops one broken screen taking the whole workspace down. The single-file
 * build caught this with window.onerror and a blank page; here the rest of the
 * shell keeps working and the error is readable.
 */
import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[render]', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="crash">
        <div className="card">
          <div className="cbody">
            <b>Something went wrong while drawing this page.</b>
            <pre>{this.state.error.message}</pre>
            <button type="button" className="btn" onClick={() => this.setState({ error: null })}>
              Try again
            </button>
          </div>
        </div>
      </div>
    );
  }
}
